module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_8011.ad9a8aed.png";